import axios from 'axios'
import ApplicationController from '../application_controller.js'

/*
 * Gestion des alertes
 */

export default class Widget12Controller extends ApplicationController {

  handle(e) {
    e.preventDefault()
    const url = `${e.target.href}?alert[status]=handled`
    axios.put(url).then(response => {
      if (response.status === 200) {
        this.element.remove()
      }
    })
  }

}